import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Spinner from 'react-spinkit';

import * as types from '../constants/actionTypes';
import SubmissionForm from "../components/SubmissionForm";
import CardBlock from "../components/bootstrap/CardBlock";
import _ from "lodash";
import {roles_self} from "../reducers/rolesReducer";

class SubmissionPage extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        const { dispatch, params } = this.props,
            { assignmentName, dropboxName } = params
        ;

        dispatch({
            type: types.ROLES__SELF__REQUESTED,
        });

        dispatch({
            type: types.DROPBOXES__REQUESTED
        });

        dispatch({
            type: types.DROPBOX__ASSIGNMENT__REQUESTED,
            payload: {
                dropboxName : dropboxName,
                assignmentName : assignmentName
            }
        });

        dispatch({
            type: types.DROPBOX__ASSIGNMENT__SUBMISSION__REQUESTED,
            payload: {
                dropboxName : dropboxName,
                assignmentName : assignmentName
            }
        });
    }

    getDropbox() {
        const { dropboxes, params } = this.props;

        return _.last(
            _.filter (dropboxes, dropbox => {
                return dropbox.name === params.dropboxName;
            })
        );
    }

    render() {
        const { sendingRequest, inProgress } = this.props.request,
            isLoading = (
                _.includes(inProgress, 'roles.doRequestRolesSelf') ||
                _.includes(inProgress, 'dropboxes.doRequestDropboxes') ||
                _.includes(inProgress, 'assignments.doRequestDropboxAssignment') ||
                _.includes(inProgress, 'assignments.doRequestDropboxAssignmentSubmission') ||
                _.includes(inProgress, 'submissions.doRequestCreateSubmission') ||
                _.includes(inProgress, 'memberships.doRequestSubmissionMemberships')
            )
        ;

        if (sendingRequest && isLoading) {
            return (
                <Spinner
                    spinnerName="wandering-cubes"
                    className="spinner"
                    noFadeIn
                />
            );
        }

        const { assignment, params, roles_self, submission } = this.props,
            dropbox = this.getDropbox()
        ;

        if (submission.id === null) {
            return (
                <CardBlock>
                    <div className="alert alert-warning" role="alert">
                        <strong>No Such Assignment.</strong>
                    </div>
                </CardBlock>
            );
        }

        if (assignment && dropbox && roles_self && submission.id) {
            return (
                <SubmissionForm
                    className="submission-form"
                    params={params}
                />
            );
        }
        return null;
    }
}

SubmissionPage.propTypes = {
    auth: PropTypes.object.isRequired,
    assignment: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    dropboxes: PropTypes.object.isRequired,
    params: PropTypes.object.isRequired,
    request: PropTypes.object.isRequired,
    roles_self: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
    submission: PropTypes.object.isRequired
};

function mapStateToProps(state) {
    const { auth, assignment, dropboxes, request, roles_self, submission } = state;

    return { auth, assignment, dropboxes, request, roles_self, submission };
}

export default connect(mapStateToProps)(withRouter(SubmissionPage));



/** WEBPACK FOOTER **
 ** ./src/containers/SubmissionPage.js
 **/